module.exports = new Promise((resolve, reject) => {
    const ENV_URLS = {
        production: 'https://assets.nuorder.com/federated/merchant-organization/remoteEntry.js',
        staging: 'https://assets.staging.nuorder.com/federated/merchant-organization/remoteEntry.js',
        staging02: 'https://assets.stg02.nuorder.com/federated/merchant-organization/remoteEntry.js',
        stg02: 'https://assets.stg02.nuorder.com/federated/merchant-organization/remoteEntry.js',
        'pre-prd': 'https://assets.pre-prd.nuorder.com/federated/merchant-organization/remoteEntry.js',
        sandbox1: 'https://assets.sandbox1.nuorder.com/federated/merchant-organization/remoteEntry.js'
    };
    const federatedPath = ENV_URLS[window.nuConfig?.ENVIRONMENT] || ENV_URLS.staging;
    
    const script = document.createElement('script');
    script.src = federatedPath;
    script.onload = () => {
        const proxy = {
            get: (request) => window.MerchantOrganization.get(request),
            init: (arg) => {
                try {
                    return window.MerchantOrganization.init(arg);
                } catch(e) {
                    console.error('MerchantOrganization remote container already initialized');
                }
            }
        };
        resolve(proxy);
    };
    script.onerror = (error) => {
        console.error('Failed to load MerchantOrganization remote from:', federatedPath, error);
        reject(new Error('Failed to load MerchantOrganization remote module'));
    };
    document.head.appendChild(script);
});